import type { ReactNode } from 'react';

/**
 * Canonical page heading — DESIGN.md §2.1, §2.2. Display serif, optical
 * sizing carries the weight (no bold above 28px). One per screen.
 *
 * Optional `actions` slot renders right-aligned alongside the title.
 */
export function PageTitle({
  children,
  actions,
  className,
}: {
  children: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div className={'flex flex-wrap items-baseline justify-between gap-3 ' + (className ?? '')}>
      <h1
        className="text-3xl tracking-tight text-fg-primary"
        style={{ fontFamily: 'var(--font-display)' }}
      >
        {children}
      </h1>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
